export default __webpack_public_path__ + "static/media/107_raijin.acce26c5.webp";